import { DeclineReasons } from '../pages/StatusPage/DeclinedPage/StatusDeclinedPage';
import { AuthenticationData } from '../store/authentication';
import { apiClient } from './apiClient';

export const getDeclinedOfferReason = async (
    proxyBaseUrl: string,
    apiKey: string,
    arn: string,
    authenticationData?: AuthenticationData,
): Promise<DeclineReasons> => {
    return apiClient<DeclineReasons>(`${proxyBaseUrl}/offers/${arn}/declined`, {
        method: 'GET',
        apiKey,
        authenticationData,
        sentryTag: 'get_declined_offer_reason',
        sentryExtra: { arn },
    });
};
